import TicketSVG from "@design-system/ui-icons/vanilla/Ticket"
import { createIcon } from "../createIcon"

export const TicketIcon = createIcon(TicketSVG)
